export default __webpack_public_path__ + "static/media/p17.a1bb91b7.png";